import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';
import Button from 'components/ui/Button';

const HeroSection = () => {
  const partnershipMetrics = [
    { metric: '50+', description: 'Partenaires Actifs', icon: 'Handshake' },
    { metric: '15+', description: 'Pays Couverts', icon: 'Globe' },
    { metric: '98%', description: 'Satisfaction Client', icon: 'Award' },
    { metric: '24/7', description: 'Support Disponible', icon: 'HeadphonesIcon' }
  ];

  return (
    <section className="relative overflow-hidden" style={{ 
      background: 'linear-gradient(135deg, #96121D 0%, #9B8E57 50%, #C4A556 100%)' 
    }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <pattern id="partnerGrid" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1" fill="rgba(255,255,255,0.3)" />
              <circle cx="12" cy="12" r="1" fill="rgba(255,255,255,0.2)" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#partnerGrid)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-semibold border border-white/30">
                <Icon name="Network" size={16} className="mr-2" />
                Partenaires & Ressources
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
                Notre Réseau{' '}
                <span style={{ color: '#C4A556' }}>d'Excellence</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-white/90 leading-relaxed">
                Des partenariats stratégiques et des ressources d'hébergement de classe mondiale 
                qui amplifient notre capacité à{' '}
                <span style={{ color: '#C4A556' }} className="font-semibold">
                  transformer l'excellence automobile
                </span>.
              </p>
              
              <p className="text-lg text-white/80">
                Collaborations technologiques, alliances sectorielles et infrastructures robustes 
                qui garantissent des services de pointe pour nos clients.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                style={{ backgroundColor: '#C4A556' }}
                className="hover:opacity-90 text-white font-semibold px-8 py-4 rounded-xl shadow-lg transition-all duration-300"
              >
                <Icon name="Users" size={20} className="mr-2" />
                Devenir Partenaire
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white/30 backdrop-blur-sm text-white hover:bg-white/10 font-semibold px-8 py-4 rounded-xl transition-all duration-300"
              >
                <Icon name="FileText" size={20} className="mr-2" />
                Catalogue Ressources
              </Button>
            </div>

            {/* Partnership Metrics */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 pt-8">
              {partnershipMetrics?.map((item, index) => (
                <div key={index} className="text-center">
                  <div className="flex justify-center mb-3">
                    <div 
                      className="w-12 h-12 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: '#C4A556' }}
                    >
                      <Icon name={item?.icon} size={24} className="text-white" />
                    </div>
                  </div>
                  <div className="text-2xl lg:text-3xl font-bold text-white mb-1">
                    {item?.metric}
                  </div>
                  <div className="text-sm text-white/80">
                    {item?.description}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Partnership Visual */}
          <div className="relative">
            <div className="relative z-10">
              <Image
                src="/assets/images/strategic_planning_collaboration_three.png"
                alt="Partenaires stratégiques collaborant sur des projets d'excellence automobile avec CRF Perfection"
                className="w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl border border-white/20"
              />
              
              {/* Floating Partnership Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl max-w-xs border border-white/30">
                <div className="flex items-center space-x-4">
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#96121D' }}
                  >
                    <Icon name="CheckCircle" size={24} className="text-white" />
                  </div>
                  <div>
                    <div className="text-lg font-bold text-gray-900">Partenariat Vérifié</div>
                    <div className="text-sm text-gray-600">Excellence Certifiée</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Background Elements */}
            <div 
              className="absolute top-8 right-8 w-32 h-32 rounded-full animate-pulse"
              style={{ backgroundColor: 'rgba(196, 165, 86, 0.3)' }}
            ></div>
            <div className="absolute bottom-16 right-16 w-20 h-20 bg-white/20 rounded-full animate-bounce"></div>
            
            {/* Icon Elements */}
            <div className="absolute top-1/4 -right-4 w-16 h-16 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center">
              <Icon name="Server" size={32} className="text-white" />
            </div>
            <div className="absolute bottom-1/4 -left-4 w-16 h-16 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center">
              <Icon name="Cloud" size={32} className="text-white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;